import Vue from 'vue'
const mimetype2fa = require('mimetype-to-fontawesome')({ prefix: 'fa-' })
import getClassNameForExtension from 'font-awesome-filetypes'


Vue.filter('formatSize', function (size) {
    if (size > 1024 * 1024 * 1024 * 1024) {
        return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + ' TB'
    } else if (size > 1024 * 1024 * 1024) {
        return (size / 1024 / 1024 / 1024).toFixed(2) + ' GB'
    } else if (size > 1024 * 1024) {
        return (size / 1024 / 1024).toFixed(2) + ' MB'
    } else if (size > 1024) {
        return (size / 1024).toFixed(2) + ' KB'
    }
    return size.toString() + ' B'
})

Vue.filter('relativeDate', function (datestring) {
    return Vue.moment(datestring).from(Vue.moment())
})

Vue.filter('attachmentClass', function (attachment) {
    var className = ''
    if (attachment.filename) {
        const extension = attachment.filename.split('.').pop()
        className = getClassNameForExtension(extension)
    }
    else if (attachment.mimetype) {
        className = mimetype2fa(attachment.mimetype)
        // Convert fontawesome v4 class names to v5
        className = className.replace(/-o$/, '')
    }
    else {
        // Fallback
        className = 'fa-file'
    }
    // console.log(`Derived ${className} for`, Object.assign({}, attachment))
    return className
})

Vue.filter('formatDateTime', datetimeString => {
    if (datetimeString) {
      return Vue.moment(datetimeString).format('DD/MM-YYYY HH:mm')
    }
  }
)

Vue.filter('formatTime', datetimeString => {
    if (datetimeString) {
        if (datetimeString.indexOf(':') !== -1){
            const parts = datetimeString.split(':')
            return `${parts[0].padStart(2, '0')}:${parts[1].padStart(2, '0')}`
        }

        return `${datetimeString.padStart(2, '0')}:00`
    }
  }
)
